export default __webpack_public_path__ + "static/1508-53b88dc0ddc296e69c4615f14cc2583e.gif";